import { render, staticRenderFns } from "./OrganizationViewAuthorizations.vue?vue&type=template&id=ba2360cc&"
import script from "./OrganizationViewAuthorizations.vue?vue&type=script&lang=js&"
export * from "./OrganizationViewAuthorizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports